var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaglioManualeYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-954 4307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.283,64.113a7.552,7.552,0,0,1-.9,1.129l2.153,2.086a10.465,10.465,0,0,1-6.524,3.147l-.289-2.986c-.238.023-.479.037-.722.037s-.485-.014-.723-.037l-.289,2.986a10.465,10.465,0,0,1-6.524-3.147l2.153-2.086a7.552,7.552,0,0,1-.9-1.129L43.2,65.748a10.439,10.439,0,0,1-1.7-5.722,10.549,10.549,0,0,1,.094-1.339l2.973.382a7.478,7.478,0,0,1,.319-1.408l-2.846-.946a10.522,10.522,0,0,1,4.519-5.658l1.555,2.563a7.454,7.454,0,0,1,1.3-.627L48.38,50.18a10.343,10.343,0,0,1,7.239,0l-1.034,2.813a7.454,7.454,0,0,1,1.3.627l1.555-2.563a10.518,10.518,0,0,1,4.519,5.658l-2.846.946a7.478,7.478,0,0,1,.319,1.408l2.973-.382a10.549,10.549,0,0,1,.1,1.339,10.44,10.44,0,0,1-1.7,5.722Z",
    transform: "translate(914 -4355)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.283,64.113a7.552,7.552,0,0,1-.9,1.129l2.153,2.086a10.465,10.465,0,0,1-6.524,3.147l-.289-2.986c-.238.023-.479.037-.722.037s-.485-.014-.723-.037l-.289,2.986a10.465,10.465,0,0,1-6.524-3.147l2.153-2.086a7.552,7.552,0,0,1-.9-1.129L43.2,65.748a10.439,10.439,0,0,1-1.7-5.722,10.549,10.549,0,0,1,.094-1.339l2.973.382a7.478,7.478,0,0,1,.319-1.408l-2.846-.946a10.522,10.522,0,0,1,4.519-5.658l1.555,2.563a7.454,7.454,0,0,1,1.3-.627L48.38,50.18a10.343,10.343,0,0,1,7.239,0l-1.034,2.813a7.454,7.454,0,0,1,1.3.627l1.555-2.563a10.518,10.518,0,0,1,4.519,5.658l-2.846.946a7.478,7.478,0,0,1,.319,1.408l2.973-.382a10.549,10.549,0,0,1,.1,1.339,10.44,10.44,0,0,1-1.7,5.722Z",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.954,56.445l2.051,5.449,2.046-5.449h1.6v7.109h-1.23V61.211l.122-3.135-2.1,5.478h-.883l-2.095-5.473.122,3.13v2.343H48.352V56.445Z",
    transform: "translate(914 -4355)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(954 -4307)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaglioManualeYellow);
export default __webpack_public_path__ + "static/media/taglio_manuale_yellow.f849681e0738f818a5ed3bca0e25d8a2.svg";
export { ForwardRef as ReactComponent };